<template>
	<div>
		<div class="head">
			<!-- <img :src="userlist.avatar" class="logo"> -->
			<h1>logo</h1>
			<div class="userbx" v-if="userlist">
				<img :src="userlist.avatar" class="user">
				<span class="username">{{userlist.userName}}</span>
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		name: 'playhead',
		components: {},
		props: {

		},
		data() {
			return {}
		},
		created() {
			this.userlist = this.$store.state.appUser
		},
		methods: {

		}
	}
</script>

<style lang="scss" scoped>
	.head {
		top: 0;
		position: fixed;
		width: 100%;
		z-index: 90;
		height: 50px;
		background-color: white;
		display: flex;
		justify-content: space-between;
		align-items: center;
		padding: 16px 0;

		.logo {
			height: 50px;
			margin-left: 5%;
		}

		.userbx {
			margin-right: 5%;
			display: flex;
			align-items: center;

			.user {
				width: 40px;
				border-radius: 100%;
			}

			.username {
				font-weight: bold;
				font-size: 16px;
				margin-left: 20px;
			}
		}
	}
</style>
